module.exports = __webpack_public_path__ + "static/media/img4.2f905b5a.jpg";